import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { Field, reduxForm } from 'redux-form'
import { push } from 'react-router-redux';

import { tryToLeaveTeam } from '../../actions/actions.export.js';
import Button from '../Button/Button.js'
import Checkbox from '../Checkbox/Checkbox.js'
import Tabs from '../Tabs/Tabs.js'
import CustomField from '../CustomField/CustomField.js'


class TeamSettingsLeaveForm extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired
  }

  constructor(props){
    super(props);

    this.state = {
      leave_email: props.team.leaveTeamForm.lastSubmit.leave_email,
      leave_password: props.team.leaveTeamForm.lastSubmit.leave_password,
    }

    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleSubmit(e){
    const { team, id } = this.props;

    var t = team.cache[id];

    if(window.confirm('Are you sure you want to leave ' + t.display_name + '?')){
      const { dispatch } = this.props;
      dispatch(tryToLeaveTeam({
        id: t.id,
        leave_email: this.state.leave_email,
        leave_password: this.state.leave_password
      }))
    }
    if(e) e.preventDefault();
  }

  render(){
    const { dispatch, user, team, id } = this.props; 
    const state = this.state;
    
    var t = team.cache[id];

    if(!t) return <i className="fal fa-spinner-third fa-spin fa-2x"/>

    let formDisabled = !state.leave_password || !state.leave_email;

    return (
      <div>
        <form onSubmit={(e) => {
          e.preventDefault();
          if(!formDisabled) this.handleSubmit()
        }}>
          <p className="">
            Enter your email and password to leave:
          </p>
          <CustomField 
            type="email"
            name="email"
            placeholder="email address"
            label="Email"
            value={state.leave_email}
            onChange={(e) => {this.setState({leave_email: e}); }}
            serverErrors={team.leaveTeamForm.errors.leave_email}
            required={true}
            regex="email"
            disabled={team.tryingToLeaveTeam}
          />

          <CustomField 
            type="password"
            name="password"
            placeholder="password"
            label="Password"
            value={state.leave_password}
            onChange={(e) => {this.setState({leave_password: e}); }}
            serverErrors={team.leaveTeamForm.errors.leave_password}
            required={true}
            disabled={team.tryingToLeaveTeam}
          />
          <ul className="bullet-list">
            <li className="text-danger"><span className="fa-li"><i className="fal fa-angle-right"></i></span>  You will no longer have access to private {t.display_name} patterns.</li>
            <li className="text-danger"><span className="fa-li"><i className="fal fa-angle-right"></i></span>  You will need a new invitation to rejoin.</li>
          </ul>
          <br/>
          <div className="list-right">
            <small className="text-danger">
              {team.leaveTeamForm.errors.alert}
            </small>
            <Button 
              submit={true}
              size="medium"
              disabled={formDisabled}
              thinking={team.tryingToLeaveTeam}
              failed={team.failedToLeaveTeam}
              color="danger" 
              display={"Leave " + t.display_name}
            />
          </div>
        </form>
      </div>
    )
  }
}


TeamSettingsLeaveForm = reduxForm({
  form: 'TeamSettingsLeaveForm',
  enableReinitialize: true,
  destroyOnUnmount: false
})(TeamSettingsLeaveForm)

TeamSettingsLeaveForm = connect((state, ownProps) => {
  const { user, team } = state;

  var initialValues = {};
  
  return {
    user,
    team,
    initialValues
  }
})(TeamSettingsLeaveForm);

export default TeamSettingsLeaveForm;



// WEBPACK FOOTER //
// ./src/components/TeamSettingsLeaveForm/TeamSettingsLeaveForm.js